import { animate, state, style, transition, trigger } from '@angular/animations';

export const PanelPerformanceAnimation = [
  trigger('hideState', [
    state(
      'active',
      style({
        'max-height': '310px'
      })
    ),
    state(
      'inactive',
      style({
        'max-height': '0px'
      })
    ),
    transition('active => inactive', animate('.4s ease-in')),
    transition('inactive => active', animate('.4s ease-in'))
  ]),

  trigger('bgState', [
    state(
      'active',
      style({
        // color: 'var(--backgroundColor)',
        color: '$backgroundColor',
        // 'background-color': 'var(--brandColor)',
        'background-color': '$brandColor'
      })
    ),
    state(
      'inactive',
      style({
        // color: 'var(--brandColor)',
        color: '$brandColor',
        // 'background-color': 'var(--backgroundColor)',
        'background-color': '$backgroundColor'
      })
    ),
    transition('active => inactive', animate('.4s ease-in')),
    transition('inactive => active', animate('.2s ease-in'))
  ])
];
